module.exports = __webpack_public_path__ + "static/media/groups.30e4cc6b.png";